// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1cprS","colMaxWidth":"Table_colMaxWidth__LzXGt"};